module.exports = require("babel-runtime/helpers/inherits");


//////////////////
// WEBPACK FOOTER
// external "babel-runtime/helpers/inherits"
// module id = 9
// module chunks = 0 1 2 3 4 5 6 7